import { render, staticRenderFns } from "./IconDotsCircleHorizontalSolid.vue?vue&type=template&id=2cd898f3"
import script from "./IconDotsCircleHorizontalSolid.vue?vue&type=script&lang=js"
export * from "./IconDotsCircleHorizontalSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports